<template>
  <div class="tops hovers" id="topss">
    <p>
      <span @click="returns(1)">首页</span>
      <span><img src="../assets/you.png" alt=""></span>
      <span @click="returns(2)">产品</span>
      <span><img src="../assets/you.png" alt=""></span>
      <span class="lastspan">MPODI神算子</span>
    </p>
  </div>
  <div class="centers">
    <div class="box1">
      <div class="boxl">
        <h3>MPODI神算子</h3>
        <p>自动采集气象数据并对接模型;用户可自建预测数学模型、共享模型、修改模型、运行数学模型，并根据模板发布病害情报，支持手机APP便捷查看气象数据和运行模型生成结果。</p>
      <p>实现1套设备运行N种不同数学模型，可以预测同一生境下的多种作物、多种病害发生趋势。</p>
      </div>
      <div class="boxr">
        <img src="../assets/mpodi.jpg" alt="">
      </div>
    </div>
    <div class="box2">
      <!-- <img src="../assets/home1.png" alt=""> -->
    </div>
    <div class="box3">
      <h4>优势</h4>
      <ul>
        <li>
          <p>低成本</p>
          <span>MPODI可以使用户在几乎没有任何数学概念的情况下构建、修改和运行数学模型。 这减少了大量数据分析所需的人力、时间和资源成本</span>
        </li>
        <li>
          <p>提高了风险管理</p>
          <span>使用户可以在更短的时间内处理和分析大量数据。MPODI提供准确和实时的结果，使您能够做出更快、更明智的决策，以防止病虫害的爆发和为害。</span>
        </li>
        <li>
          <p>更高的准确性</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    returns(e) {

      if (e == 1) {
        this.$router.push({ path: "/" })

      }
      if (e == 2) {
        this.$router.push({ path: '/Chanpin' })
      }

    },
  },
  created() { },
  mounted() { }
}
</script>

<style scoped>

.box1{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  margin: auto;
  margin-top: 3rem;
  margin-bottom: 5rem;
  /* border: 1px solid; */
}
.box1 .boxl{
  width: 45%;
  /* border: 1px solid; */
}
.box1 .boxr{
  width: 48%;
  /* border: 1px solid; */
  overflow: hidden;
}
.box1 .boxr img{
  width: 100%;
}
.boxl h3{
  font-size: 1.4rem;
  margin-bottom: 2rem;

}
.boxl p{
  text-indent: 2em;
  font-size: 0.8rem;
  line-height: 1.6;
  letter-spacing: 3px;
}
@keyframes rotate360 {
        100% {
           transform: scale(1.3);
        }
    }
.boxr:hover img{
  animation:  rotate360 7s linear  infinite;
}
.box2{
  /* width: 100%; */
  height: 60vh;
  margin: auto;
  /* position: fixed; */
  /* border: 1px solid red; */
  /* opacity: 0; */
  position: relative;
  overflow: hidden;
  z-index: 1;
  background: url(../assets/home1.png) no-repeat center fixed;

  background-size: 46%;
  /* border: 1px solid red; */
}

.box2 img{
  width: 100%;
  
}
.box3{
  /* height: 60vh; */
  margin-top: 2rem;
}
.box3 h4{
  text-align: center;
  font-size: 1.4rem;
  font-weight: bold;
  line-height: 2;
  margin-bottom: 1rem;
}
.box3 ul{
  width: 52%;
  margin: auto;
}
.box3 ul li{
  margin-bottom: 4rem;
  /* border: 1px solid; */
}
.box3 ul li p{
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 1rem;
  position: relative;
  letter-spacing: 3px;
}
.box3 ul li p::after{
  position: absolute;
  content: "";
  width: 1rem;
  height: 1rem;
  top: 50%;
  left: -2rem;
  transform: translateY(-50%);
  background: url(../assets/duihao.png) no-repeat center;
  background-size: 100%;
}
.box3 ul li span{
  font-size: 0.8rem;
  display: inline-block;
  line-height: 1.6;
  letter-spacing: 3px;
}
</style>